/* hs-eslint ignored failing-rules */

'use es6';

import ActionTypes from './ActionTypes';
import { postProgressTransferRequest, verifyTransferProgress } from '../api/ProgressTransferApi';
import Raven from 'raven-js';
function progressTransferRequesting() {
  return {
    type: ActionTypes.PROGRESS_TRANSFER_REQUESTING
  };
}
function progressTransferRequestCompletion() {
  return {
    type: ActionTypes.PROGRESS_TRANSFER_REQUEST_COMPLETION
  };
}
function progressTransferRequestError(error) {
  Raven.captureException(error);
  return {
    type: ActionTypes.PROGRESS_TRANSFER_REQUEST_ERROR,
    error: true,
    payload: error
  };
}
export function sendProgressTransferRequest(email) {
  return dispatch => {
    dispatch(progressTransferRequesting());
    postProgressTransferRequest(email).then(() => dispatch(progressTransferRequestCompletion()), errorResponse => dispatch(progressTransferRequestError(errorResponse))).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };
}
function progressTransferVerificationRequesting() {
  return {
    type: ActionTypes.VERIFY_PROGRESS_TRANSFER_REQUESTING
  };
}
function progressTransferVerificationSuccess() {
  return {
    type: ActionTypes.VERIFY_PROGRESS_TRANSFER_SUCCESS
  };
}
function progressTransferVerificationError(error) {
  Raven.captureException(error);
  return {
    type: ActionTypes.VERIFY_PROGRESS_TRANSFER_ERROR,
    error: true,
    payload: error
  };
}
export function verifyProgressTransferRequest(confirmationGuid) {
  return dispatch => {
    dispatch(progressTransferVerificationRequesting());
    verifyTransferProgress(confirmationGuid).then(() => dispatch(progressTransferVerificationSuccess()), errorResponse => dispatch(progressTransferVerificationError(errorResponse))).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };
}